<template>
	<div>
		<div class="row">
			<div v-if="showTitle" class="col-md-12 mb-1 d-flex align-items-center justify-content-center">
				<div>
					<h5>Fuel {{ tabLabel }}</h5>
				</div>
				<div class="ml-auto">

					<el-checkbox border size="small" class="me-2" v-model="showchart" v-show="tabIndex == 0 || tabIndex >= 4 && tabName != 'hose_delivery' && tabName != 'grading_station_summary' && tabName != 'grading_station' && tabName !='atg_online' && tabName != 'edc_detail'">
						Show Chart
					</el-checkbox>

					<el-popover trigger="click" size="small" ref="dropdown" v-model="dropdownVisible" popper-class="dropdown-filter">
						<el-button slot="reference" type="primary" plain size="small">
							<i class="fa fa-filter"></i> &nbsp; Filter
						</el-button>
						<div>
							<div class="ps-3 pe-3 pt-1 pb-1">
								<h5><i class="fa fa-filter"></i> &nbsp; Filter {{ tabLabel }}</h5>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="dropdown-filter-form">
								<el-form label-position="top" label-width="100px">
									<div class="row">
										<div class="col-md-6" v-if="tabName !='outlet' && tabName !='rkap_vs_realisasi' && tabName !='grading_station_summary' && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' && tabName != 'edc_detail' ">
											<el-form-item label="Station">
												<el-radio-group v-model="detail1" size="small" name="detail1">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail1" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
										<div class="col-md-6 col-xs-12" v-if="tabName !='outlet' && tabName !='grading_station_summary'">
											<el-form-item label="Search:">
												<el-select v-model="stationid" clearable filterable placeholder="Search" size="medium" style="width:100%;">
													<el-option v-for="item3 in spbu.list" :key="item3.BranchId" :label="item3.StationName" :value="item3.StationId">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

                                        <div class="col-md-6 col-xs-12" v-if="tabName =='edc_detail'">
											<el-form-item label="Bank:">
												<el-select v-model="bankid" clearable filterable placeholder="Search Bank" size="medium" style="width:100%;">
													<el-option v-for="item3 in options.bank" :key="item3.value" :label="item3.name" :value="item3.value">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

									</div>

									<div class="row" v-if="tabIndex != 3">
										<div class="col-md-6" v-if="tabIndex < 4 || tabName == 'outlet' || tabName =='grading_station' || tabName =='hose_delivery' || tabName =='atg_online' || tabName == 'edc_detail'  ">
											<!--<ReportParamDateRange title="Date" v-model="date" />-->
											<el-form-item label="Date Range:">
												<div class="block">
													<el-date-picker
													v-model="dateRange"
													type="daterange"
													align="right"
													size="small"
													unlink-panels
													range-separator="-"
													start-placeholder="Start date"
													end-placeholder="End date"
													format="yyyy-MM-dd"
													value-format="yyyy-MM-dd"
													:picker-options="pickerOptions">
													</el-date-picker>
												</div>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabIndex > 3 && tabName != 'outlet' && tabName !='grading_station_summary' && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' && tabName != 'edc_detail'  ">
											<el-form-item label="Month Range:">
												<div class="block">
													<el-date-picker
													v-model="monthRange"
													type="monthrange"
													align="right"
													size="small"
													unlink-panels
													range-separator="-"
													start-placeholder="Start Month"
													end-placeholder="End Month"
													format="yyyy-MM"
													value-format="yyyy-MM"
													:picker-options="pickerOptionsMonth">
													</el-date-picker>
												</div>
											</el-form-item>
										</div>
										<div class="col-md-2" v-if="tabName =='grading_station_summary' && tabName !='atg_online'">
											<el-form-item label="Tahun:" style="min-width:85px;">
												<el-select v-model="year" filterable placeholder="Select Year" size="medium" style="width:100%;">
													<el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
													</el-option>
												</el-select>
											</el-form-item>
										</div>
										<div class="col-md-6" v-if="tabIndex < 4 || tabName=='outlet'  && tabName !='grading_station_summary' && tabName != 'hose_delivery' && tabName !='atg_online'">
											<el-form-item label="Periods">
												<el-radio-group v-model="period" size="small" name="period">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.period" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
									</div>

									<div class="row">
										<div class="col-md-6" v-if="(tabName !='atg_online' && is2024OrBelow) || tabName == 'stock'  || tabName=='outlet' ">
											<el-form-item label="Area">
												<el-radio-group v-model="area" size="small" name="area">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabName !='atg_online' && is2025OrAbove && tabName != 'edc_detail'">
                                            <el-form-item label="" v-if="tabName == 'sales'" class="form-app">
                                                <el-checkbox :indeterminate="isIndeterminateRegion" v-model="checkAllRegion" @change="handleCheckAllChangeRegion">Region (Multi)</el-checkbox>
												<el-checkbox-group v-model="regions" size="small" name="regions" class="mt-1" @change="handleCheckedChangeRegion">
													<el-checkbox-button :label="item5.value" v-for="(item5, index5) in options.region.filter(item => item.value && item.value != 'region')" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-checkbox-button>
												</el-checkbox-group>
											</el-form-item>

											<el-form-item label="Region" v-else>
												<el-radio-group v-model="region" size="small" name="region">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabName !='rkap_vs_realisasi' && tabName != 'hose_delivery' && tabName !='atg_online' && tabName != 'edc_detail'">
											<el-form-item label="" v-if="tabName == 'sales'" class="form-app">
                                                <el-checkbox :indeterminate="isIndeterminateOwner" v-model="checkAllOwner" @change="handleCheckAllChangeOwner">Owner (Multi)</el-checkbox>
												<el-checkbox-group v-model="owners" size="small" name="owners" class="mt-1" @change="handleCheckedChangeOwner">
													<el-checkbox-button :label="item5.value" v-for="(item5, index5) in options.owner.filter(item => item.value)" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-checkbox-button>
												</el-checkbox-group>
											</el-form-item>

                                            <el-form-item label="Owner" v-else>
												<el-radio-group v-model="owner" size="small" name="owner">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-show="tabIndex != 2 && tabName != 'outlet' && tabName !='rkap_vs_realisasi' && tabName !='grading_station_summary'  && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' && tabName != 'edc_detail'">
											<el-form-item label="Products">
												<el-radio-group v-model="detail2" size="small" name="detail2">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail2" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
										<div class="col-md-6" v-if="tabIndex == 2 && tabName !='atg_online'">
											<el-form-item label="Payment">
												<el-radio-group v-model="detail3" size="small" name="detail3">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail3" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
										<div class="col-md-6" v-if="tabIndex == 3 && tabName !='atg_online'">
											<el-form-item label="Status">
												<el-radio-group v-model="status" size="small" name="status">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-12" v-if="tabName !='rkap_vs_realisasi' && tabName != 'hose_delivery' && tabName !='atg_online' && tabName != 'edc_detail'">
											<el-form-item label="" v-if="tabName == 'sales'" class="form-app">
                                                <el-checkbox :indeterminate="isIndeterminateType" v-model="checkAllType" @change="handleCheckAllChangeType">Station Type (Multi)</el-checkbox>
												<el-checkbox-group v-model="stationtypes" size="small" name="types" class="mt-1" @change="handleCheckedChangeType">
													<el-checkbox-button :label="item5.value" v-for="(item5, index5) in options.types.filter(item => item.value)" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-checkbox-button>
												</el-checkbox-group>
											</el-form-item>

                                            <el-form-item label="Type" v-else>
												<el-radio-group v-model="stationtype" size="small" name="type">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="tabName !='rkap_vs_realisasi' && tabName !='grading_station_summary' && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' && tabName != 'edc_detail' ">
											<el-form-item label="" v-if="tabName == 'sales'" class="form-app">
                                                <el-checkbox :indeterminate="isIndeterminateLocation" v-model="checkAllLocation" @change="handleCheckAllChangeLocation">Location (Multi)</el-checkbox>
												<el-checkbox-group v-model="locations" size="small" name="locations" class="mt-1" @change="handleCheckedChangeLocation">
													<el-checkbox-button :label="item5.value" v-for="(item5, index5) in options.lokasi.filter(item => item.value)" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-checkbox-button>
												</el-checkbox-group>
											</el-form-item>

                                            <el-form-item label="Tol" v-else>
												<el-radio-group v-model="lokasi" size="small" name="lokasi">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.lokasi" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

									</div>

									<!--
									<div class="row" v-if="tabName=='outlet'">
										<div class="col-md-6">
											<el-form-item label="Detail:">
												<el-select v-model="detail" clearable filterable placeholder="Select Detail" size="medium" style="width:100%;">
													<el-option v-for="item3 in options.detail" :key="item3.value" :label="item3.name" :value="item3.value">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

										<div class="col-md-6" >
											<el-form-item label="Active:">
												<el-radio-group v-model="active" size="small" name="active">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.active" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

									</div>
									-->
								</el-form>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="py-2 px-4">
								<div class="row">
									<div class="col-md-12 d-flex align-items-center">
										<div class="ml-auto">
											<el-button type="danger" size="medium" @click="closeDropdownForm" style="min-width:100px;"><i class="fa fa-close"></i> &nbsp; Close</el-button>
											<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="min-width:100px;"><i class="fa fa-check"></i> &nbsp; Apply Filter</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-popover>

					<el-button class="ms-2" type="success" plain size="small" @click="exportExcel()" v-if="reportdata?.data?.length">
						<i class="fa fa-file-excel"></i> &nbsp; Export
					</el-button>
					<vue-excel-xlsx
						v-show="false"
						ref="excelExport"
						:data="dataXLSX(reportdata)"
						:columns="columnXLSX(reportdata)"
						:file-name="'Fuel ' + tabLabel"
						:file-type="'xlsx'"
						:sheet-name="'sheet1'"
						>
						<i class="far fa-file-excel"></i>
					</vue-excel-xlsx>

				</div>
			</div>

			<div class="mb-2" v-if="!showTitle">
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6" v-if="tabName !='outlet' && tabName !='rkap_vs_realisasi' && tabName !='grading_station_summary' && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' ">
									<el-form-item label="Station">
										<el-radio-group v-model="detail1" size="small" name="detail1">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail1" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName !='outlet' && tabName !='grading_station_summary'">
									<el-form-item label="Search:">
										<el-select v-model="stationid" clearable filterable placeholder="Search" size="medium" style="width:100%;">
											<el-option v-for="item3 in spbu.list" :key="item3.BranchId" :label="item3.StationName" :value="item3.StationId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

							</div>

							<div class="row" v-if="tabIndex != 3">
								<div class="col-md-6" v-if="tabIndex < 4 || tabName == 'outlet' || tabName =='grading_station' || tabName =='hose_delivery' || tabName =='atg_online'  ">
									<!--<ReportParamDateRange title="Date" v-model="date" />-->
									<el-form-item label="Date Range:">
										<div class="block">
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small"
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabIndex > 3 && tabName != 'outlet' && tabName !='grading_station_summary' && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' ">
									<el-form-item label="Month Range:">
										<div class="block">
											<el-date-picker
											v-model="monthRange"
											type="monthrange"
											align="right"
											size="small"
											unlink-panels
											range-separator="-"
											start-placeholder="Start Month"
											end-placeholder="End Month"
											format="yyyy-MM"
											value-format="yyyy-MM"
											:picker-options="pickerOptionsMonth">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>
								<div class="col-md-2" v-if="tabName =='grading_station_summary' && tabName !='atg_online'">
									<el-form-item label="Tahun:" style="min-width:85px;">
										<el-select v-model="year" filterable placeholder="Select Year" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabIndex < 4 || tabName=='outlet'  && tabName !='grading_station_summary' && tabName != 'hose_delivery' && tabName !='atg_online'">
									<el-form-item label="Periods">
										<el-radio-group v-model="period" size="small" name="period">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.period" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>

							<div class="row">
								<div class="col-md-6" v-if="(tabName !='atg_online' && is2024OrBelow) || tabName == 'stock'  || tabName=='outlet' ">
									<el-form-item label="Area">
										<el-radio-group v-model="area" size="small" name="area">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName !='atg_online' && is2025OrAbove ">
									<el-form-item label="Region">
										<el-radio-group v-model="region" size="small" name="region">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName !='rkap_vs_realisasi' && tabName != 'hose_delivery' && tabName !='atg_online'">
									<el-form-item label="Owner">
										<el-radio-group v-model="owner" size="small" name="owner">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-show="tabIndex != 2 && tabName != 'outlet' && tabName !='rkap_vs_realisasi' && tabName !='grading_station_summary'  && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' ">
									<el-form-item label="Products">
										<el-radio-group v-model="detail2" size="small" name="detail2">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail2" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabIndex == 2 && tabName !='atg_online'">
									<el-form-item label="Payment">
										<el-radio-group v-model="detail3" size="small" name="detail3">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail3" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabIndex == 3 && tabName !='atg_online'">
									<el-form-item label="Status">
										<el-radio-group v-model="status" size="small" name="status">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-12" v-if="tabName !='rkap_vs_realisasi' && tabName != 'hose_delivery' && tabName !='atg_online'">
									<el-form-item label="Type">
										<el-radio-group v-model="stationtype" size="small" name="type">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName !='rkap_vs_realisasi' && tabName !='grading_station_summary' && tabName !='grading_station' && tabName != 'hose_delivery' && tabName !='atg_online' ">
									<el-form-item label="Tol">
										<el-radio-group v-model="lokasi" size="small" name="lokasi">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.lokasi" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>

							<!--
							<div class="row" v-if="tabName=='outlet'">
								<div class="col-md-6">
									<el-form-item label="Detail:">
										<el-select v-model="detail" clearable filterable placeholder="Select Detail" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.detail" :key="item3.value" :label="item3.name" :value="item3.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6" >
									<el-form-item label="Active:">
										<el-radio-group v-model="active" size="small" name="active">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.active" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>
							-->

							<div class="row mt-2">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row" v-show="tabIndex == 0 || tabIndex >= 4 && tabName != 'hose_delivery' && tabName != 'grading_station_summary' && tabName != 'grading_station' && tabName !='atg_online' && tabName != 'edc_detail'">
				<div class="col-md-3 mb-3" v-if="!showTitle">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>
				<div class="col-md-4 mb-1 me-4" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="barchart" size="small">Bar Chart</el-radio>
						<el-radio label="linechart" size="small">Line Chart</el-radio>
					</el-radio-group>
				</div>
                <div class="col-md-1 me-4" v-if="showchart && charttype=='barchart' ">
                    <el-checkbox v-model="stacked" class="mr-4">Stacked</el-checkbox>
                </div>
                <div class="col-md-1" v-if="showchart" >
                    <el-checkbox v-model="showValue" class="mr-4">Show Value</el-checkbox>
                </div>

				<div class="col-md-12" v-if="showchart">
					<el-radio-group v-model="showtype" v-if="tabIndex == 4 || tabIndex == 5" >
						<el-radio label="value" size="small">Difference Volume</el-radio>
						<el-radio label="percentage" size="small">Percentage</el-radio>
						<el-radio label="comparison" size="small">Comparison Volume</el-radio>
					</el-radio-group>
					<el-radio-group v-model="showtypesc" v-if="tabIndex == 6" >
						<el-radio label="value" size="small">Sales Volume</el-radio>
						<el-radio label="percentage" size="small">Percentage</el-radio>
					</el-radio-group>

                    <el-radio-group v-model="salescharttype" v-if="tabName == 'sales'" >
						<el-radio label="saleschartbyproduct" size="small">By Product</el-radio>
						<el-radio label="saleschartbyarea" size="small">By Area</el-radio>
						<el-radio label="saleschartbyregion" size="small">By Region</el-radio>
						<el-radio label="saleschartstocksalescomparation" size="small">Sales VS Stock Volume (KL)</el-radio>
					</el-radio-group>
				</div>

				<div class="col-md-12 mb-3" v-if="showchart && tabName=='outlet'">
					<el-radio-group v-model="outletcharttype">
						<el-radio label="chartbygrowth" size="small">Growth</el-radio> <!--
						<el-radio label="chartbygrowtharea" size="small">Growth By Area</el-radio>
						<el-radio label="chartbygrowthregion" size="small">Growth By Region</el-radio> -->
						<el-radio label="chartbygrowthowner" size="small">Growth By Owner</el-radio>
						<el-radio label="chartbygrowthtype" size="small">Growth By Type</el-radio>

						<el-radio label="chartbyperiod" size="small">By Period</el-radio> <!--
						<el-radio label="chartbyarea" size="small">By Area</el-radio>
						<el-radio label="chartbyregion" size="small">By Region</el-radio> -->
						<el-radio label="chartbytype" size="small">By Type</el-radio>
					</el-radio-group>
				</div>

			</div>
			<div class="mb-0" >
				<BarChart class="mb-3" v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" :totalValue="this.totalValue" :showValue="showValue"/>
				<LineChart class="mb-3" v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='linechart'" style="margin-top:20px;" :showValue="showValue"/>
			</div>

			<div class="mt-1">
				<!--<ReportResultTable :reportname="'FuelReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> -->
				<ReportResultTable v-if="tabIndex < 6 || tabIndex > 6 " :reportname="'FuelReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/>
				<ReportResultTableWithFooter v-else :reportname="'FuelReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;" :footerMethod="getSummaries"/>
			</div>

			<div class="mt-4" v-show="tabName == 'grading_station' ">
				<div class="text-center mt-4"><h5>Summary Grading Pertamina Way</h5></div>
				<ReportResultTable :reportname="'FuelReportSummary'" :reportdata="reportdatasummarygradingpertaminaway" :loading="loading.tableSummaryGradingPertaminaWay" :reporturl="urlRequestParams" :issuccess="loading.isSuccessSummaryGradingPertaminaWay" style="width:100%;" :key="'grading_summary'"/>
			</div>

		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2Custom.vue'
import ReportResultTableWithFooter from '@/views/pages/ReportResultTable3WithFooter.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart2.js'
import BarChart from '@/components/chart/BarChart2.js'

export default
{
	extends: Fuel,
	props: ['tabIndex','tabName', 'tabLabel', 'showTitle'],
	components: {
		//ReportParamSelect,
		ReportResultTable,
		ReportResultTableWithFooter,
		LineChart,
		BarChart,
	},

	data(){
		return {
			date: {
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin,
			},
			urlRequestParams: '',
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" },
					{ value: "station", name: "BY STATION" },
					//{ value: "tank", name: "BY TANK" },
				],
				detail2:[
					{ value: "", name: "ALL" },
					{ value: "group", name: "BY GROUP", field: "ProductGroup" },
					{ value: "product", name: "BY PRODUCT", field: "ProductName" },
				],
				detail3:[
					{ value: "", name: "ALL" },
					{ value: "cash", name: "BY CASH" },
					{ value: "payment", name: "BY METHOD" },
				],
				area:[
					{ value: "", name: "ALL" },
					{ value: "area", name: "BY AREA", field: "SalesArea" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
				region:[
					{ value: "", name: "ALL" },
					{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
				owner:[
					{ value: "", name: "ALL" },
					//{ value: "by_owner", name: "BY OWNER" },
					{ value: "COCO", name: "COCO" },
					{ value: "KSO", name: "KSO" },
					{ value: "TAC", name: "TAC" },
				],
				lokasi:[
					{ value: "", name: "ALL" },
					//{ value: "by_location", name: "BY LOCATION" },
					{ value: "TOL", name: "TOL" },
					{ value: "NON TOL", name: "NON TOL" },
				],
				status:[
					{ value: "", name: "ALL" },
					{ value: "NORMAL", name: "NORMAL" },
					{ value: "LOW", name: "LOW" },
					{ value: "CRITICAL", name: "CRITICAL" },
				],
				active:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "ACTIVE" },
					{ value: "0", name: "INACTIVE" },
				],
				types:[
					{ value: '', name: 'ALL' },
					//{ value: 'by_station_type', name: 'BY STATION TYPE' },
					{ value: 'SPBU', name: 'SPBU' },
					{ value: 'SPBG', name: 'SPBG' },
					{ value: 'PERTASHOP', name: 'PERTASHOP' },
					{ value: 'SPBU-T', name: 'SPBU-T' },
					{ value: 'SHELTER', name: 'SHELTER' },
					{ value: 'MODULAR', name: 'MODULAR' },
				],

				detail:[
					{ value: "", name: "Detail Per Station" },
					{ value: "area", name: "Rekap Per Area" },
					{ value: "type", name: "Rekap Per Type" },
					{ value: "area_type", name: "Rekap Per Type Per Area" },
					{ value: "hose", name: "Rekap Nozzle" },
					{ value: "area_hose", name: "Rekap Nozzle Per Area" },
					{ value: "station_hose", name: "Rekap Nozzle Per Station" },
					{ value: "pos", name: "Detail Pos" },
				],
				presentation:[
					{ value: "1", name: "Table" },
					{ value: "9", name: "Chart" },
					{ value: "8", name: "Map" },
				],
				years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
                bank: [
                    { value: 1, name: "BANK CENTRAL ASIA" },
                    { value: 2, name: "BANK MANDIRI" },
                    { value: 3, name: "CIMB NIAGA" },
                    { value: 4, name: "BANK NEGARA INDONESIA" },
                    { value: 5, name: "DANAMOND" },
                    { value: 6, name: "BANK RAKYAT INDONESIA" },
                    { value: 7, name: "BANK CENTRAL ASIA ( VISA & MASTER )" },
                    { value: 8, name: "BANK CENTRAL ASIA ( DEBIT & FLAZZ )" },
                    { value: 9, name: "BANK MANDIRI ( VISA & MASTER )" },
                    { value: 10, name: "BANK MANDIRI ( DEBIT & FLAZZ )" },
                    { value: 11, name: "CIMB NIAGA ( VISA & MASTER )" },
                    { value: 12, name: "CIMB NIAGA ( DEBIT & FLAZZ )" },
                    { value: 13, name: "BANK NEGARA INDONESIA ( VISA & MASTER )" },
                    { value: 14, name: "BANK NEGARA INDONESIA ( DEBIT & FLAZZ )" },
                    { value: 15, name: "DANAMOND ( VISA & MASTER )" },
                    { value: 16, name: "DANAMOND ( DEBIT & FLAZZ )" },
                    { value: 17, name: "BANK RAKYAT INDONESIA ( VISA & MASTER )" },
                    { value: 18, name: "BANK RAKYAT INDONESIA ( DEBIT & FLAZZ )" },
                    { value: 19, name: "BANK MEGA (VISA & MASTER)" },
                    { value: 20, name: "BANK MEGA (DEBIT & FLAZZ)" },
                    { value: 22, name: "PASPAY" },
                    { value: 23, name: "BANK BNI SYARIAH ( VISA & MASTER )" },
                    { value: 24, name: "My Pertamina" },
                    { value: 25, name: "GO-PAY" },
                    { value: 26, name: "T-CASH" },
                    { value: 27, name: "BANK MEGA" },
                    { value: 28, name: "LINKAJA" },
                    { value: 29, name: "BPP LINKAJA" },
                    { value: 30, name: "GRAB" },
                    { value: 31, name: "PT BANK TABUNGAN NEGARA ( DEBIT & FLAZZ )" },
                    { value: 32, name: "PT BANK TABUNGAN NEGARA ( VISA & MASTER )" },
                    { value: 33, name: "MerchantApp MyPertamina" },
                    { value: 34, name: "OVO" },
                    { value: 35, name: "BPP BTN" },
                    { value: 36, name: "BANK SYARIAH INDONESIA" },
                    { value: 37, name: "BPP AJ" },
                    { value: 38, name: "PT ARTAJASA (DEBIT)" },
                    { value: 39, name: "PT ARTAJASA (CREDIT)" },
                    { value: 40, name: "BANK SYARIAH INDONESIA ( VISA & MASTER )" },
                    { value: 41, name: "BANK SYARIAH INDONESIA ( DEBIT & FLAZZ )" },
                    { value: 42, name: "BANK TABUNGAN NEGARA" },
                    { value: 43, name: "PT. BANK TABUNGAN NEGARA (DEBIT)" },
                    { value: 44, name: "PT. BANK TABUNGAN NEGARA (VISA)" }
                ]
			},

			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			charttype: 'linechart', //barchart //linechart
			reportdata: [],
			chartdata: [],
			reportdatasummarygradingpertaminaway: [],
			showchart: false,
			stacked: true,
			showtype: 'value', //value, percentage
			showtypesc: 'value', //value, percentage
			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().bulanSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin],
			monthRange:[], //[this.$route.query.monthStart ? this.$route.query.monthStart : Penanggalan().tahun + '-' + Penanggalan().bulan, this.$route.query.monthEnd ? this.$route.query.monthEnd : Penanggalan().tahun + '-' + Penanggalan().bulan]
			city:'',
			presentation:'1',
			detail:'',
			outletcharttype: 'chartbygrowth',
			active:'',
			totalValue: '',
			reportdatachart: [],

			plantno: this.$route.query.plant ? this.$route.query.plant : '',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : '',
			period: this.$route.query.period ? this.$route.query.period : 'daily',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : 'product',
			detail3: this.$route.query.detail3 ? this.$route.query.detail3 : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : 'region',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			satgas: this.$route.query.satgas ? this.$route.query.satgas : '',

			bankid: this.$route.query.bankid ? this.$route.query.bankid : '',

			year: Penanggalan().tahun,

			loading: {
				table: false,
				chart: false,
				isSuccess: false,
				tableSummaryGradingPertaminaWay: false,
				isSuccessSummaryGradingPertaminaWay: false,
			},

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			pickerOptionsMonth: {
				shortcuts: [
					{
						text: 'This month',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					},
					{
						text: 'This year',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: 'Last 6 months',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},

			showValue: false,
			is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,
			filteredData2024AndBelow: [],
			filteredData2025AndAbove: [],
			//salescharttype: 'saleschartall',

			salescharttype: 'saleschartbyproduct',

            //New Multiselect
            regions: [],
            isIndeterminateRegions: false,
            checkAllRegion: false,

            owners: [],
            isIndeterminateOwner: false,
            checkAllOwner: false,

            stationtypes: [],
            isIndeterminateType: false,
            checkAllType: false,

            locations: [],
            isIndeterminateLocation: false,
            checkAllLocation: false,
		}
	},
	watch: {
		//date(){ this.resumePilihan() },
		//plantno() { this.resumePilihan() },
		//stationid() { this.resumePilihan() },
		reportdata() { this.refreshChart(); },
		reportdatachart() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
		showtype() { this.refreshChart(); },
		showtypesc() { this.refreshChart(); },
		//showtypesaleschart() { this.refreshChart(); },
		outletcharttype() { this.refreshChart(); },
		salescharttype() { this.refreshChart(); },
		//stationtype(){ this.resumePilihan() },
		dateRange(newValue, oldValue) {
			let yearCategory = this.getYearCategory(newValue);
			// && is2024OrBelow
			if(yearCategory == 1) {
				//year 2025 or above
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;

				this.region = 'region';
				this.area = '';
				this.salescharttype = 'saleschartregion'
			} else if(yearCategory == 2) {
				//year 2024 or below
				this.is2024OrBelow = true;
				this.is2025OrAbove = false;

				this.region = '';
                //this.regions = [];
				this.area = 'area';
                this.checkAllRegion = false;
				this.salescharttype = 'saleschartarea'
                console.log('checkAllRegion: ' + this.checkAllRegion);
			} else {
				//year mixed
				this.is2024OrBelow = true;
				this.is2025OrAbove = true;

				this.region = 'region';
				this.area = 'area';
				this.salescharttype = 'saleschartall'
			}

			//console.log('area: ' + this.area);
			//console.log('region: ' + this.region);
		},
		monthRange(newValue, oldValue) {
			let yearCategory = this.getYearCategory2(newValue);
			// && is2024OrBelow
			if(yearCategory == 1) {
				//year 2025 or above
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;

				this.region = 'region';
				this.area = '';
			} else if(yearCategory == 2) {
				//year 2024 or below
				this.is2024OrBelow = true;
				this.is2025OrAbove = false;

				this.region = '';
                //this.regions = [];
                this.checkAllRegion = false;
				this.area = 'area';
			} else {
				//year mixed
				this.is2024OrBelow = true;
				this.is2025OrAbove = true;

				this.region = 'region';
				this.area = 'area';
			}
			//console.log('monthRange' + newValue);
		},

	},
    mounted() {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')

		if(this.tabIndex == 3) {
			let tankFilter = { value: "tank", name: "BY TANK" };
			this.options.detail1.push(tankFilter);
		}

		if(this.tabIndex == 4 || this.tabIndex == 5 || this.tabIndex == 6) {
			let addOptionsItemOwner = { value: "by_owner", name: "BY OWNER" };
			let addOptionsItemType = { value: 'by_station_type', name: 'BY STATION TYPE' };
			let addOptionsItemLocation = { value: "by_location", name: "BY LOCATION" }
			//this.options.owner.push(addOptionsItemOwner);
			//this.options.types.push(addOptionsItemType);
			//this.options.lokasi.push(addOptionsItemLocation);

			this.options.owner.splice(1, 0, addOptionsItemOwner);
			this.options.types.splice(1, 0, addOptionsItemType);
			this.options.lokasi.splice(1, 0, addOptionsItemLocation);
		}

		if(this.tabName =='outlet') {
			this.detail1 = 'station'
			this.stacked = false
			this.charttype = 'barchart'

			//remove daily
			/*
			this.options.period = [
					{ value: '', name: 'ALL' },
					//{ value: 'daily', name: 'DAILY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				]
			*/
			let elementToRemove = { value: 'daily', name: 'DAILY' };
			let indexToRemove = this.options.period.findIndex(obj => obj.value === elementToRemove.value);
			if (indexToRemove !== -1) {
				this.options.period.splice(indexToRemove, 1);
			}

			this.period = 'monthly'
			this.dateRange = [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin]
			this.resumePilihanChart()
		} else if(this.tabName == 'rkap_vs_realisasi') {
			this.monthRange = [Penanggalan().tahunSekarang,Penanggalan().kemarin]
		} else if(this.tabName == 'grading_station') {
			this.area = ''
			this.getSummaryGradingPertaminaWay()
		} else if(this.tabName == 'grading_station_summary') {
			this.area = ''
		} else if(this.tabName =='margin_tac') {
			this.area = ''
			this.monthRange = [Penanggalan().tahun + '-' + Penanggalan().bulan, Penanggalan().tahun + '-' + Penanggalan().bulan]
		} else if(this.tabName =='hose_delivery') {
			this.area = ''
			this.dateRange = [Penanggalan().bulanSekarang,Penanggalan().sekarang]
		} else if(this.tabName == 'atg_online') {
			this.dateRange = [Penanggalan().sekarang,Penanggalan().sekarang]
		}

        this.$emit('childrenRoute');
		this.loadStationList()
		//this.resumePilihan()

    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		refreshChart() {
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""

			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a

			let b = "Period"
			let c = (a == "ProductName") ? FuelColor : Rainbow
			if (this.tabIndex == 4 || this.tabIndex == 5) {
				let valuecol = 'DifferenceSalesVolume';
				if(this.showtype == 'percentage') {
					valuecol = 'SalesVolumePercentage';
					this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.showtype == 'value') {
					this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
				} else {
					let chartdatacomparison = []
					this.reportdata.data.forEach((item) => {
						//console.log('item: '+JSON.stringify(item));
						let monthA = {
							label: item.label,
							legend: 'Month 1',
							value: item.SalesVolume0,
						};
						chartdatacomparison.push(monthA)

						let monthB = {
							label: item.label,
							legend: 'Month 2',
							value:  item.SalesVolume,
						};
						chartdatacomparison.push(monthB)

					});

					this.chartdata = this.processBarChart(chartdatacomparison, "legend", "", "value", false, "label", "", 1, 2, c, false, false, false, this.stacked);
				}

			} else if(this.tabIndex == 6) {
				let valuecol = 'SalesVolume';
				if(this.showtypesc == 'percentage')
					valuecol = 'Percentage';
				this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
			} else if(this.tabIndex == 7) {
				let valuecol = 'PerformBBM';
				this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
			} else if(this.tabIndex == 8) {
				c = Rainbow
				let valuecol = 'Jumlah'
				let legend = 'SalesArea'
				let label = ''
				let prefix = ''

				if(this.outletcharttype == 'chartbygrowth') {
					//empty
					prefix = ''
					legend = 'legend'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbygrowtharea') {
					//empty
					prefix = 'AREA '
					legend = 'SalesArea'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbygrowthregion') {
					//empty
					prefix = 'REGION '
					legend = 'RegionPertareId'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				}else if(this.outletcharttype == 'chartbygrowthowner') {
					//empty
					prefix = ''
					legend = 'OwnershipType'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbygrowthtype') {
					//empty
					prefix = ''
					legend = 'StationType'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbyarea') {
					this.totalValue = ''
					//empty
					prefix = 'Area '
					legend = 'SalesArea'
					label = ''
					valuecol = 'Cnt'
					this.chartdata = this.processBarChart(this.reportdata.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbyregion') {
					this.totalValue = ''
					//empty
					prefix = 'REGION '
					legend = 'RegionPertareId'
					label = ''
					valuecol = 'Cnt'
					this.chartdata = this.processBarChart(this.reportdata.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbytype') {
					this.totalValue = ''
					//empty
					prefix = ''
					legend = 'StationType'
					label = ''
					valuecol = 'Cnt'
					this.chartdata = this.processBarChart(this.reportdata.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbyperiod') {
					this.totalValue = ''
					//empty
					prefix = ''
					legend = 'legend'
					label = 'period'
					valuecol = 'Cnt'
					this.chartdata = this.processBarChart(this.reportdata.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				}

			} else if(this.tabIndex == 12) {
				let prefix = ''
				a = 'legend'
				b = 'label'
				c = Rainbow
				let valuecol = 'PendapatanPTPR'

				if(this.area == 'area') {
					a = 'legend'
					b = 'label'
					valuecol = 'PendapatanPTPR' //Cnt
				}
				this.chartdata = this.processBarChart(this.reportdata.data, a, prefix, valuecol, false, b, "", 1, 2, c, false, false, false, this.stacked);
			} else if(this.tabName == 'sales') {

				if(this.salescharttype == 'saleschartbyarea') {
					this.chartdata = this.processBarChart(this.chartDataArea, "SalesArea", "AREA ", "SalesVolume", false, "Period", "", 1, 2, c, false, false, false, this.stacked);
					//console.log('chart area');
				} else if(this.salescharttype == 'saleschartbyregion') {
					this.chartdata = this.processBarChart(this.chartDataRegion, "RegionPertareId", "REGION ", "SalesVolume", false, "Period", "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart region');
				}  else if(this.salescharttype == 'saleschartstocksalescomparation') {
					this.chartdata = this.processBarChart(this.chartDataSalesAndStock, "Legend", "", "Volume", false, "Period", "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart region');
				} else {
					this.chartdata = this.processBarChart(this.reportdata.data, "ProductName" , "", "SalesVolume", false, "Period", "", 1, 2, Rainbow, false, false, false, this.stacked);
					//this.chartdata = this.processBarChart(this.chartDataRegion, "RegionPertareId", "REGION ", "SalesVolume", false, "Period", "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart all');
				}

			} else {
				this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesVolume", false, b, "", 1, 2, c, false, false, false, this.stacked);
			}
		},

		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/fuel2/sales?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/fuel2/losses?'
			else if (this.tabIndex == 2) this.urlRequestParams+='/fuel2/payment?'
			else if (this.tabIndex == 3) this.urlRequestParams+='/fuel2/stock?'
			else if (this.tabIndex == 4) this.urlRequestParams+='/v1/fuel2/growthByMonth?'
			else if (this.tabIndex == 5) this.urlRequestParams+='/v1/fuel2/growthByYear?'
			else if (this.tabIndex == 6) this.urlRequestParams+='/v1/fuel2/salesContribution?'
			else if (this.tabIndex == 7) this.urlRequestParams+='/v1/fuel2/rkapvsrealisasi?'
			else if (this.tabIndex == 8) this.urlRequestParams+='/v1/fuel2/outlet?' //outletchart?
			else if (this.tabIndex == 9) this.urlRequestParams+='/v1/fuel2/hosedelivery?'
			else if (this.tabIndex == 10) this.urlRequestParams+='/v1/fuel2/gradingstation?'
			else if (this.tabIndex == 11) this.urlRequestParams+='/v1/fuel2/gradingstationsummary?'
			else if (this.tabIndex == 12) this.urlRequestParams+='/v1/fuel2/margintac?'
			else if (this.tabIndex == 13) this.urlRequestParams+='/v1/fuel2/atgonline?'
			else if (this.tabIndex == 14) this.urlRequestParams+='/v1/fuel2/edcdetail?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End

			//console.log('daterange: ' + this.dateRange)
			//console.log('this.dateRange[0]: ' + this.dateRange[0])
			//console.log('this.dateRange[1]: ' + this.dateRange[1])

			this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')

			//if(this.monthRange[0] != 'undefined')
			this.urlRequestParams+='&month-range-start='+ (this.monthRange && this.monthRange[0] ? this.monthRange[0] : '')

			//if(this.monthRange[1] != 'undefined')
			this.urlRequestParams+='&month-range-end='+ (this.monthRange && this.monthRange[1] ? this.monthRange[1] : '')

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&plant='+this.plantno
			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&type='+this.stationtype
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&owner='+this.owner
			this.urlRequestParams+='&lokasi='+this.lokasi
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&satgas='+this.satgas
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2 + '_' + this.detail3

			this.urlRequestParams+='&city='+this.city
			this.urlRequestParams+='&presentation='+this.presentation
			this.urlRequestParams+='&detailView='+this.detail
			this.urlRequestParams+='&active='+this.active
			this.urlRequestParams+='&tahun='+this.year
			this.urlRequestParams+='&bankid='+this.bankid

            //multi
            this.urlRequestParams+='&regions='+this.regions
            this.urlRequestParams+='&owners='+this.owners
            this.urlRequestParams+='&stationtypes='+this.stationtypes
            this.urlRequestParams+='&locations='+this.locations

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})

        },

		async resumePilihanChart() {
			//only for growth outlet
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/fuel2/sales?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/fuel2/losses?'
			else if (this.tabIndex == 2) this.urlRequestParams+='/fuel2/payment?'
			else if (this.tabIndex == 3) this.urlRequestParams+='/fuel2/stock?'
			else if (this.tabIndex == 4) this.urlRequestParams+='/v1/fuel2/growthByMonth?'
			else if (this.tabIndex == 5) this.urlRequestParams+='/v1/fuel2/growthByYear?'
			else if (this.tabIndex == 6) this.urlRequestParams+='/v1/fuel2/salesContribution?'
			else if (this.tabIndex == 7) this.urlRequestParams+='/v1/fuel2/rkapvsrealisasi?'
			else if (this.tabIndex == 8) this.urlRequestParams+='/v1/fuel2/outletChart?' //outletchart?


			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End

			this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

			//if(this.monthRange[0] != 'undefined')
			this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

			//if(this.monthRange[1] != 'undefined')
			this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&plant='+this.plantno
			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&type='+this.stationtype
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&owner='+this.owner
			this.urlRequestParams+='&lokasi='+this.lokasi
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&satgas='+this.satgas
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2 + '_' + this.detail3

			this.urlRequestParams+='&city='+this.city
			this.urlRequestParams+='&presentation='+this.presentation
			this.urlRequestParams+='&detailView='+this.detail
			this.urlRequestParams+='&active='+this.active

			//this.loading.table = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					this.reportdatachart = response.data;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					//this.loading.table = false;
				})

			},

		async getSummaryGradingPertaminaWay(){
			let urlRequestParams=Config().apiURL
			if (this.tabName == 'grading_station')
				urlRequestParams+='/v1/fuel2/gradingstationsummary?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End

			//console.log('daterange: ' + this.dateRange)
			//console.log('this.dateRange[0]: ' + this.dateRange[0])
			//console.log('this.dateRange[1]: ' + this.dateRange[1])

			urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

			//if(this.monthRange[0] != 'undefined')
			urlRequestParams+='&month-range-start='+ this.monthRange[0]

			//if(this.monthRange[1] != 'undefined')
			urlRequestParams+='&month-range-end='+ this.monthRange[1]

			urlRequestParams+='&period='+this.period
			urlRequestParams+='&plant='+this.plantno
			urlRequestParams+='&station='+this.stationid
			urlRequestParams+='&type='+this.stationtype
			urlRequestParams+='&area='+this.area
			urlRequestParams+='&region='+this.region
			urlRequestParams+='&owner='+this.owner
			urlRequestParams+='&lokasi='+this.lokasi
			urlRequestParams+='&status='+this.status
			urlRequestParams+='&satgas='+this.satgas
			urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2 + '_' + this.detail3

			urlRequestParams+='&city='+this.city
			urlRequestParams+='&presentation='+this.presentation
			urlRequestParams+='&detailView='+this.detail
			urlRequestParams+='&active='+this.active
			urlRequestParams+='&tahun='+this.year

			this.loading.tableSummaryGradingPertaminaWay = true;
			this.loading.isSuccessSummaryGradingPertaminaWay = false;
			AxiosWithJar().get(urlRequestParams)
				.then((response)=>{
					this.loading.isSuccessSummaryGradingPertaminaWay = true;
					this.reportdatasummarygradingpertaminaway = response.data;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.tableSummaryGradingPertaminaWay = false;
				})

        },

		applyFilter() {
            if(this.is2024OrBelow) {
                this.regions = [];
                this.checkAllRegion = false;
                //console.log('2024 below');
            }

            if(this.is2025OrAbove) {
                this.area = '';
            }

			this.resumePilihan()
			if(this.tabName =='outlet') {
				this.resumePilihanChart()
			} else if(this.tabName =='grading_station') {
				this.getSummaryGradingPertaminaWay()
			}
			this.dropdownVisible = false;
        },

		exportExcel() {
			this.$refs["excelExport"].exportExcel();
			//console.log('export excel');
		},

		closeDropdownForm() {
			this.dropdownVisible = false;
		},

		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				//console.log('column param: ' + JSON.stringify(column))
				//console.log('column index: ' + index)
				//console.log('column name: ' + column.property)

				//console.log('data: ' + JSON.stringify(data))

				if (index === 0) {
					sums[index] = 'Total';
					return;
				}

				if(column.property == 'SalesVolume') {
					//sums[index] = '0'

					const arrayItem = this.reportdata.data.map(element => element.SalesVolume);
					//console.log('arrayItem: ' + JSON.stringify(arrayItem));

					const sum = this.reportdata.data.map(element => element.SalesVolume).reduce((prev, curr) => prev + curr, 0);
					sums[index] = sum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')

					/*
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = '' + values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
					} else {
						sums[index] = '';
					}
					*/
					return;
				}

				if(column.property == 'Percentage') {
					//sums[index] = '0'
					const sumPercentage = this.reportdata.data.map(element => element.Percentage).reduce((prev, curr) => prev + curr, 0);
					sums[index] = sumPercentage.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
					return;
				}

			});

			return sums;
		},

        //Multiple Select Owner
        handleCheckAllChangeOwner(val) {
            //this.owners = val ? this.options.owner.map(item => item.value) : [];
            this.owners = val
                ? this.options.owner
                    .filter(item => item.value)        // hanya ambil yang value-nya tidak kosong
                    .map(item => item.value)           // ambil value-nya saja
                : [];
            this.isIndeterminateOwner = false;
        },
        handleCheckedChangeOwner(value) {
            let checkedCount = value.length;
            this.checkAllOwner = checkedCount === (this.options.owner.length - 1);
            this.isIndeterminateOwner = checkedCount > 0 && checkedCount < (this.options.owner.length - 1);
        },

        //Multiple Select Branch Type
        handleCheckAllChangeType(val) {
            //this.owners = val ? this.options.owner.map(item => item.value) : [];
            this.stationtypes = val
                ? this.options.types
                    .filter(item => item.value)        // hanya ambil yang value-nya tidak kosong
                    .map(item => item.value)           // ambil value-nya saja
                : [];
            this.isIndeterminateType = false;
        },
        handleCheckedChangeType(value) {
            let checkedCount = value.length;
            this.checkAllType = checkedCount === (this.options.types.length - 1);
            this.isIndeterminateType = checkedCount > 0 && checkedCount < (this.options.types.length - 1);
        },

        //Multiple Select Location (Tol, Non Tol)
        handleCheckAllChangeLocation(val) {
            //this.owners = val ? this.options.owner.map(item => item.value) : [];
            this.locations = val
                ? this.options.lokasi
                    .filter(item => item.value)        // hanya ambil yang value-nya tidak kosong
                    .map(item => item.value)           // ambil value-nya saja
                : [];
            this.isIndeterminateLocation = false;
        },
        handleCheckedChangeLocation(value) {
            let checkedCount = value.length;
            this.checkAllLocation = checkedCount === (this.options.lokasi.length - 1);
            this.isIndeterminateLocation = checkedCount > 0 && checkedCount < (this.options.lokasi.length - 1);
        },

        //Multiple Select Region
        handleCheckAllChangeRegion(val) {
            //this.owners = val ? this.options.owner.map(item => item.value) : [];
            this.regions = val
                ? this.options.region
                    .filter(item => item.value)        // hanya ambil yang value-nya tidak kosong
                    .map(item => item.value)           // ambil value-nya saja
                : [];
            this.isIndeterminateRegion = false;
        },
        handleCheckedChangeRegion(value) {
            let checkedCount = value.length;
            this.checkAllRegion = checkedCount === (this.options.region.length - 2);
            this.isIndeterminateRegion = checkedCount > 0 && checkedCount < (this.options.region.length - 2);
        },


    },
	computed: {
		chartDataArea() {
			// Filter data for period 2024 and below
			return this.reportdata?.data?.filter(item => {
				const year = new Date(item.Period).getFullYear();
				return year <= 2024;
			});
		},
		chartDataRegion() {
			// Filter data for period 2025 and above
			return this.reportdata?.data?.filter(item => {
				const year = new Date(item.Period).getFullYear();
				return year > 2024;
			});
		},
        chartDataSalesAndStock() {
            return this.reportdata?.data?.flatMap(item => [
                {
                    Period: item.Period,
                    RegionPertareId: item.RegionPertareId,
                    MOR: item.MOR,
                    ProductName: item.ProductName,
                    ProductGroup: item.ProductGroup,
                    NumDays: item.NumDays,
                    Legend: "Sales Volume",
                    Volume: item.SalesVolume / 1000
                },
                {
                    Period: item.Period,
                    RegionPertareId: item.RegionPertareId,
                    MOR: item.MOR,
                    ProductName: item.ProductName,
                    ProductGroup: item.ProductGroup,
                    NumDays: item.NumDays,
                    Legend: "Stock Volume",
                    Volume: item.StockVolume / 1000
                }
            ]);
        },
	},
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/*
.el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 0px !important;
}
*/

.dropdown-filter-form {
	padding:20px;
	max-height: 320px;
	overflow: auto;
}

.dropdown-filter {
	margin:10px !important;
	padding: 8px 0px !important;
}

@media (min-width: 768px) {
	.dropdown-filter {
		margin:10px;
		max-width:70%;

	}
}

@media (min-width: 320px) {
	.dropdown-filter {
		margin:10px;
	}
}

.form-app .el-form-item__content  {
    line-height: normal;
}

</style>
